import BaseIcon from './base/BaseIcon.vue';
import BaseButton from './ui/button/BaseButton.vue';
import ButtonRow from './ui/button/ButtonRow.vue';
import BaseInput from './ui/form/controls/BaseInput.vue';
import BaseCheckbox from './ui/form/controls/BaseCheckbox.vue';
import BaseToggle from './ui/form/controls/BaseToggle.vue';
import SimpleCheckbox from './ui/form/controls/SimpleCheckbox.vue';
import VSelect from './ui/form/controls/VSelect.vue';
import MultiSelect from './ui/form/controls/MultiSelect.vue';
import BaseForm from './ui/form/BaseForm.vue';
import GroupRadio from './ui/form/controls/GroupRadio.vue';
import SimpleModal from './ui/modal/SimpleModal.vue';
import BaseAlert from './ui/BaseAlert.vue';
import CustomTransition from './base/CustomTransition.vue';
import StringLoader from './base/StringLoader.vue';
import TooltipIcon from './ui/TooltipIcon.vue';

//expand
import ExpandPanel from './ui/expand-panel-component/ExpandPanel.vue';
import ExpandPanelItem from './ui/expand-panel-component/ExpandPanelItem.vue';

import HtmlRender from './HtmlRender.vue';
export default function (app) {
  app.component('HtmlRender', HtmlRender)
  app.component('ExpandPanelItem', ExpandPanelItem)
  app.component('ExpandPanel', ExpandPanel)
  app.component('TooltipIcon', TooltipIcon)
  app.component('BaseIcon', BaseIcon)
  app.component('BaseInput', BaseInput)
  app.component('BaseCheckbox', BaseCheckbox)
  app.component('BaseToggle', BaseToggle)
  app.component('BaseForm', BaseForm)
  app.component('BaseButton', BaseButton)
  app.component('VSelect', VSelect)
  app.component('CustomSelect', MultiSelect)
  app.component('GroupRadio', GroupRadio)
  app.component('SimpleModal', SimpleModal)
  app.component('BaseAlert', BaseAlert)
  app.component('ButtonRow', ButtonRow)
  app.component('SimpleCheckbox', SimpleCheckbox)
  app.component('CustomTransition', CustomTransition)
  app.component('StringLoader', StringLoader)
}